import { useQuery } from '@apollo/client';
import { CusipMuniInfo } from '@bakerweb/models';
import { GET_CUSIP_MUNI_INFOS } from '../graphql/queries/getCusipMuniInfos';

export const useGetCusipMuniInfos = (skip = 0, take = 1000, positionIds: string[] | null = null) => {
  const { loading, error, data, refetch } = useQuery<{
    cusipMuniInfos: CusipMuniInfo[];
  }>(GET_CUSIP_MUNI_INFOS, {
    variables: { skip, take, positionIds },
    skip: !positionIds || !positionIds.length,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first'
  });

  const cusipMuniInfos = data?.cusipMuniInfos ?? [];

  return { loading, error, cusipMuniInfos, refetch };
};
